
import docTitle from "./assets/js/document.js";
import banner from "./components/banner.vue";
import foot from "./components/footer.vue"
export default {
  name: 'App',
  components: {
    banner,
    foot
  },
  data() {
    return {
      message: '',
      isSuccess: false,
      topScroll: 0,
      loginFlag: false,
      onShow: true,
    }
  },
  mounted() {
    window.onscroll = () => {
      var top = document.documentElement.scrollTop || document.body.scrollTop;
      this.topScroll = top

    };
    docTitle()
    this.onShow = window.localStorage.getItem("cookies") == 'false' ? false : true
  },
  methods: {
    toLoginWhatsApp() {
      window.open(`https://whatsapp.yoni-tech.com/console/#/entry/login`);
    },
    onClose() {
      this.onShow = false
      document.cookie = 'false'
      window.localStorage.setItem("cookies", false)
    },

    toLogin() {
      let lang = window.localStorage.getItem("language") == 'EN' ? 'en' : 'zh'
      window.open(`https://sgzz.yoni-tech.com/login?lang=${lang}`);
    },
    closeLogin() {
      document.querySelector('body').style.overflow = 'auto'
      this.loginFlag = false
    },
    loginShow(bollean) {
      document.querySelector('body').style.overflow = 'hidden'
      this.loginFlag = bollean
    },
    getMsg(e, boolean) {
      this.message = e;
      this.isSuccess = boolean;
      setTimeout(() => {
        this.message = "";
      }, 1500);
    },
  }
}
